import React, { useEffect, useState } from "react";
// import ButtonLoading from "../../Loader/ButtonLoading";
import { ToastContainer } from "react-toastify";
import { useForm } from "react-hook-form";
// import IconParkCorrect from "../../IconParkCorrect";
// import Loader from "../../Loader/Loader";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

const SearchImage = ({ imageValue }) => {
  const [disabled, setDisabled] = useState(false);
  const [page, setPage] = useState(0);
  const [isLoading, setisLoading] = useState(true);
  const [images, setImages] = useState([]);
  const axiosPrivate = useAxiosPrivate();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getSingleImages = async () => {
      const res = await axiosPrivate.get(`article/listImages?pages=${page}`, {
        withCredentials: true,
        signal: controller.signal,
      });
      console.log(res.data);
      setImages([...images, ...res.data?.Images]);

      setisLoading(false);
    };

    getSingleImages();

    return () => {
      isMounted = false;
      controller.abort();
      setisLoading(false);
    };
  }, [page]);
  const loadMoreImages = async () => {
    // const res = await axios.get(`article/listPublicArticles?pages=${page}`, {
    //   withCredentials: true,
    //   signal: controller.signal,
    // });
    setisLoading(true);
    setPage(page + 1);
    setisLoading(false);
  };
  return (
    <>
      <ToastContainer />
      <div className="p-3">
        <div className="mt-3">
          <form
            className="mx-3"
            onSubmit={handleSubmit((data) => {
              console.log(data);
              //   setDisabled()
              //   handleUpload(data.searchImage);
            })}
          >
            <div className="">
              <label className="my-3 block text-white dark:text-white">
                search Image
              </label>
              <div>
                <div className="flex mt-3 ">
                  <input
                    {...register("searchImage", {
                      required: "This field is required.",
                    })}
                    type="text"
                    placeholder="image copyright text"
                    className=" w-full  rounded-lg border-[1.5px] border-stroke bg-transparent py-1 px-5 text-white outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                  />
                  <button
                    disabled={disabled}
                    type="submit"
                    className={`inline-flex ${
                      disabled ? "opacity-50" : ""
                    }   items-center justify-center ms-2 rounded-md border border-primary py-1 px-3 text-center font-small text-primary hover:bg-opacity-90 `}
                  >
                    {disabled ? "loading" : "ok"}
                  </button>
                </div>
              </div>
            </div>

            {/* {url && <img src={url} alt="Uploaded" />} */}
          </form>
          <div className="">
            {isLoading == true
              ? "loading"
              : images.length > 0
              ? images.map((image, index) => {
                  console.log(image);
                  return (
                    <div
                      onClick={() => {
                        // Call the parent callback function
                        console.log(image, "child image aData");
                        imageValue(image);
                      }}
                      key={index}
                      className="flex cursor-pointer my-3 border  justify-start items-center"
                    >
                      <img
                        src={image.imageURL}
                        style={{ height: "50px", width: "80px" }}
                        className=""
                      />

                      <div className="flex ms-3 flex-col justify-center items-start">
                        <small className="bg-black px-2 py-1 rounded">
                          ID : {image.imageId}
                        </small>
                        <small className="">@{image.imageCopyright}</small>
                      </div>
                    </div>
                  );
                })
              : "images not fetched"}
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchImage;
